<div class="date-picker">
    <input
      #element
      type="date"
      (change)="changeDate(element.value)"
      [value]="model | dateToInvertedString"
      [min]="_min"
      [max]="_max"
      [disabled]="control.disabled || parentFormVMDisabled()"
      >
      <!-- (change)="onChange($event.target)" -->
</div>
